export const EXPLAINER_VIDEO_URL = "https://www.youtube.com/embed/ic_iNO9kx_E?si=5IPGZ3uqb772CSQj";
